//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CooperativeTrustee",
};
